export const appFetch = async (url: string, options: RequestInit = {}) => {
  const csrf = document.querySelector("meta[name='csrf-token']")?.getAttribute('content');
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-Token': csrf || '',
    ...options.headers,
  };

  const response = await fetch(url, { ...options, headers });

  if (!response.ok) {
    // Error responses carry { message } (see UsersController#login); fall back to the status line.
    const body = await response.json().catch(() => null);
    throw new Error(body?.message ?? `Failed to fetch: ${response.statusText}`);
  }

  return response.json();
};
